// Older practical assessment comments were saved with literal <br /> tags. Comments are shown as
// text, so turn those tags into line breaks. Never render a comment as HTML: it holds user input.
const BR_TAG_REGEX = /\s*<br\s*\/?>\s*/gi;

export const formatCommentText = (text: string): string => text.replace(BR_TAG_REGEX, '\n').trim();
